module.exports = __webpack_public_path__ + "img/carga-welcome.bb38d7a1.svg";